/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useLayoutEffect } from "react";
// import { Link } from "react-router-dom";
import { useSelector, shallowEqual, connect, useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Card,
  CardBody,
  ModalProgressBar,
} from "../../../_metronic/_partials/controls";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../_metronic/_helpers";
import * as auth from "../Auth";
import { Button, Form, Col, Row, Table, Tabs, Tab } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { selectUser } from "../../modules/Auth/_redux/authRedux";
import {
  selectDataIdUser,
  fetchIdUser,
  selectLoading,
} from "../../pages/user/userSlice";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { QuickLink } from "./QuickLink";
import {
  fetchIdMenuFav,
  fetchMenuModal,
  selectDataMenuModal,
  selectIdMenuFav,
} from "../../pages/menu/menuSlice";

function AccountInformation(props) {
  // Fields
  // const [loading] = useState(false);
  const dispatch = useDispatch();
  const dataIdUser = useSelector(selectDataIdUser);
  const loading = useSelector(selectLoading);
  const dataMenu = useSelector(selectDataMenuModal);
  const dataIdMenuFav = useSelector(selectIdMenuFav);
  const dataMe = useSelector(auth.selectMe);

  const [listOffice, setListOffice] = useState([]);
  const [listPhone, setListPhone] = useState([]);

  // const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user, shallowEqual);
  useEffect(() => {}, [user]);

  const dataUser = useSelector(selectUser);

  // UI Helpers
  const userName = user.data.userName;

  useEffect(() => {
    if (dataUser.username !== null) {
      dispatch(fetchIdUser(dataUser.username));
    }
  }, [dataUser]);

  useEffect(() => {
    if (dataIdUser !== null) {
      const initData = dataIdUser.userOffices.map((item, index) => {
        return {
          ...item,
          no: index + 1,
          role_name:
            item.roles === null
              ? ""
              : item.roles.map((item) => item.role_description).join(","),
        };
      });

      const initData2 = dataIdUser.employee === null ? [] : dataIdUser.employee.contactpersons.map((item, index) => {
        return {
          ...item,
          no: index + 1,
        };
      });

      console.log(initData2, "initData2");

      setListOffice(initData);
      setListPhone(initData2);
    }
  }, [dataIdUser]);

  // New
  const columns = [
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "60px" },
      headerAlign: "center",
      hidden: true,
    },
    {
      text: "Office Code",
      dataField: "office_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Office Name",
      dataField: "office_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Roles",
      dataField: "role_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
  ];

  // quick link

  const [tableData, setTableData] = useState([]);
  const [listMenu, setListMenu] = useState([]);
  const [tableData2, setTableData2] = useState([]);
  const [force, setForce] = useState(false);

  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRowsMove, setSelectedRowsMove] = useState([]);

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load
      await dispatch(fetchIdMenuFav(dataMe.user_id));
      await dispatch(
        fetchMenuModal({
          pageNo: 1,
          pageSize: -1,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  useLayoutEffect(() => {
    const data = dataIdMenuFav === null ? [] : dataIdMenuFav;

    const items = data.filter((item) => item.menu_mobile !== "Y");

    const initData2 = items.map((item, index) => {
      return {
        ...item,
        no: index + 1,
      };
    });

    setTableData2(initData2);

    let temp = [];

    const availableItems = dataMe.usernav.filter(
      (item) => item.menu_mobile !== "Y"
    );

    availableItems.forEach((menu) => {
      if (menu.childs.length === 0) {
        // menu without child
        temp = [...temp, menu];
      } else {
        // menu with childs
        temp = [...temp, menu];
        menu.childs.map((submenu) => {
          if (submenu.childs.length === 0) {
            // submenu without childs
            temp = [...temp, submenu];
          }
        });
      }
    });

    let _temp = [...temp];

    const newData = _temp.filter(
      (item) => !initData2.some((t) => t.menu_id === item.menu_id)
    );

    setTableData(newData);
  }, [dataIdMenuFav]);

  useEffect(() => {
    // Add number
    if (force === true) {
      setSelectedRows([]);
      setSelectedRowsMove([]);
    }
  }, [force]);

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    dataIdUser && (
      <Tabs defaultActiveKey="Employee Details" id="uncontrolled-tab-example">
        <Tab eventKey="Employee Details" title="Employee Details">
          <Card>
            <CardBody>
              <Form>
                <Form.Group as={Row}>
                  <Col sm={6}>
                    <Form.Group as={Row}>
                      <Form.Label column sm={3}>
                        <b>Employee ID</b>
                      </Form.Label>
                      <Col sm={6}>
                        <Form.Control
                          type="text"
                          value={
                            dataIdUser.employee === null
                              ? ""
                              : dataIdUser.employee.emp_id
                          }
                          disabled
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row}>
                      <Form.Label column sm={3}>
                        <b>Name</b>
                      </Form.Label>
                      <Col sm={6}>
                        <Form.Control
                          type="text"
                          value={
                            dataIdUser.employee === null
                              ? ""
                              : dataIdUser.employee.username
                          }
                          disabled
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row}>
                      <Form.Label column sm={3}>
                        <b>User ID</b>
                      </Form.Label>
                      <Col sm={6}>
                        <Form.Control
                          type="text"
                          value={
                            dataIdUser.employee === null
                              ? ""
                              : dataIdUser.employee.username
                          }
                          disabled
                        />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row}>
                      <Form.Label column sm={3}>
                        <b>Job Role</b>
                      </Form.Label>
                      <Col sm={6}>
                        <Form.Control
                          type="text"
                          value={
                            dataIdUser.employee === null
                              ? ""
                              : dataIdUser.employee.designation
                          }
                          disabled
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row}>
                      <Form.Label column sm={3}>
                        <b>Address Line 1</b>
                      </Form.Label>
                      <Col sm={6}>
                        <Form.Control
                          type="text"
                          value={
                            dataIdUser.employee === null
                              ? ""
                              : dataIdUser.employee.address1
                          }
                          disabled
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row}>
                      <Form.Label column sm={3}>
                        <b>Address Line 2</b>
                      </Form.Label>
                      <Col sm={6}>
                        <Form.Control
                          type="text"
                          value={
                            dataIdUser.employee === null
                              ? ""
                              : dataIdUser.employee.address2
                          }
                          disabled
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                  {/* Right Row */}
                  <Col sm={6}>
                    <Form.Group as={Row}>
                      <Form.Label column sm={3}>
                        <b>City</b>
                      </Form.Label>
                      <Col sm={6}>
                        <Form.Control
                          type="text"
                          value={
                            dataIdUser.employee === null
                              ? ""
                              : dataIdUser.employee.city
                          }
                          disabled
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row}>
                      <Form.Label column sm={3}>
                        <b>Zip Code</b>
                      </Form.Label>
                      <Col sm={6}>
                        <Form.Control
                          type="text"
                          value={
                            dataIdUser.employee === null
                              ? ""
                              : dataIdUser.employee.zipcode
                          }
                          disabled
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row}>
                      <Form.Label column sm={3}>
                        <b>Province</b>
                      </Form.Label>
                      <Col sm={6}>
                        <Form.Control
                          type="text"
                          value={
                            dataIdUser.employee === null
                              ? ""
                              : dataIdUser.employee.province
                          }
                          disabled
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row}>
                      <Form.Label column sm={3}>
                        <b>Country</b>
                      </Form.Label>
                      <Col sm={6}>
                        <Form.Control
                          type="text"
                          value={
                            dataIdUser.employee === null
                              ? ""
                              : dataIdUser.employee.country_name
                          }
                          disabled
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row}>
                      <Form.Label column sm={3}>
                        <b>Email</b>
                      </Form.Label>
                      <Col sm={6}>
                        <Form.Control
                          type="text"
                          value={
                            dataIdUser.employee === null
                              ? ""
                              : dataIdUser.employee.cp_email
                          }
                          disabled
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Form.Group>
              </Form>
              <hr></hr>
              <p className="title-card-new ">Contact Details</p>
              <Form>
                {listPhone.map((field, idx) => {
                  return (
                    <Form.Group as={Row}>
                      <Col sm={6}>
                        <Form.Group as={Row}>
                          <Form.Label column sm={3}>
                            <b>Phone Number</b>
                          </Form.Label>
                          <Col sm={6}>
                            <Form.Control
                              type="text"
                              value={field.phone}
                              disabled
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                      {/* Right Row */}
                      <Col sm={6}>
                        <Form.Group as={Row}>
                          <Form.Label column sm={3}>
                            <b>Type</b>
                          </Form.Label>
                          <Col sm={6}>
                            <Form.Control
                              type="text"
                              value={field.phone_type}
                              disabled
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Form.Group>
                  );
                })}
              </Form>
              <hr></hr>
              <p className="title-card-new ">Base Office</p>
              <Form>
                <Form.Group as={Row}>
                  <Col sm={6}>
                    <Form.Group as={Row}>
                      <Form.Label column sm={3}>
                        <b>Base Office</b>
                      </Form.Label>
                      <Col sm={6}>
                        <Form.Control
                          type="text"
                          // onChange={(e) => {
                          //   setUsername(e.target.value);
                          // }}
                          value={dataIdUser.base_office}
                          disabled
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                  {/* Right Row */}
                  <Col sm={6}>
                    {/* <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>City</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control type="text" value={"Cikarang"} disabled />
                  </Col>
                </Form.Group> */}
                  </Col>
                </Form.Group>
              </Form>
              <hr></hr>
              <p className="title-card-new ">Role in Office</p>

              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden rounded"
                bootstrap4
                //
                keyField="No"
                data={listOffice}
                columns={columns}
                // sort={{ dataField: sortField, order: sortOrder }}
                hover
                striped
                headerClasses="header-class"
              />
            </CardBody>
          </Card>
        </Tab>
        <Tab eventKey="Quick Link Setup" title="Quick Link Setup">
          <QuickLink
            tableData={tableData}
            setTableData={setTableData}
            listMenu={listMenu}
            setListMenu={setListMenu}
            tableData2={tableData2}
            setTableData2={setTableData2}
            force={force}
            setForce={setForce}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            selectedRowsMove={selectedRowsMove}
            setSelectedRowsMove={setSelectedRowsMove}
          />
        </Tab>
      </Tabs>
    )
  );
}
export default connect(null, auth.actions)(AccountInformation);
